import { SessionSpan, SessionTrace } from '@trace/types';

export type SpansMap = Record<string, { span?: SessionSpan; spans: string[] }>;

export const getSpansSorted = (spansMap: SpansMap, spans: string[]): string[] =>
  spans
    .filter((a) => spansMap[a])
    .sort((a, b) => {
      const aSpan = spansMap[a].span as SessionSpan;
      const bSpan = spansMap[b].span as SessionSpan;
      return aSpan.start - bSpan.start || bSpan.durationMs - aSpan.durationMs;
    });

export const getSpansParent = (spansMap: SpansMap): string[] => {
  const ids = [];

  for (const value of Object.values(spansMap)) {
    if (value.span && !value.span.parentSpanId) {
      ids.push(value.span.spanId);
    }
  }

  return getSpansSorted(spansMap, ids);
};

export const getSpansMap = (traces: SessionTrace[]): SpansMap => {
  const spansMap: SpansMap = {};

  for (const trace of traces) {
    for (const span of trace.spans) {
      if (!spansMap[span.spanId]) {
        spansMap[span.spanId] = { span, spans: [] };
      }

      if (!spansMap[span.spanId].span) {
        spansMap[span.spanId].span = span;
      }

      if (span.parentSpanId) {
        if (!spansMap[span.parentSpanId]) {
          spansMap[span.parentSpanId] = {
            spans: [],
          };
        }

        if (!spansMap[span.parentSpanId].spans.includes(span.spanId)) {
          spansMap[span.parentSpanId].spans.push(span.spanId);
        }
      }
    }
  }

  for (const span in spansMap) {
    if (Object.hasOwnProperty.call(spansMap, span)) {
      spansMap[span].spans = getSpansSorted(spansMap, spansMap[span].spans);
    }
  }

  return spansMap;
};

export const getSpansFlat = (
  spansMap: SpansMap,
  spans: SessionSpan[] = [],
  ids = getSpansParent(spansMap),
): SessionSpan[] => {
  for (const id of ids) {
    const value = spansMap[id];

    if (value.span) {
      spans.push(value.span);
      getSpansFlat(spansMap, spans, value.spans);
    }
  }

  return spans;
};

export default function getOrderedSpans(traces: SessionTrace[]): SessionSpan[] {
  const spansMap = getSpansMap(traces);
  const spansFlat = getSpansFlat(spansMap);

  return spansFlat;
}
